export var deviceBreakPoints = {
    // Device includes desktop
    Desktop: "(min-width: 1280px)",
    // Device includes ipads
    Ipad: "(min-width: 1024px) and (max-width: 1279px)",
    // Large Phone devices
    PhoneLarge: "(min-width: 812px) and (max-width: 1023px)",
    // Phone Devices
    Phones: "(min-width: 320px) and (max-width: 767px)",
    // Phone Device Potrait
    PhonePortrait: "(max-width: 480px) and (orientation: portrait)",
    // Phone Device Landscape
    PhoneLandscape: "(max-width: 992px) and (orientation: landscape)",
    // iPad Portrait and above
    IpadPortrait: "(min-width: 768px) and (max-width: 1023px)",
    //iPad Portrait and landscape
    IpadPortraitAndLandscape: "(min-width: 768px) and (max-width: 1279px)",
    //iPad and iPhones
    IpadIphone: "(min-width: 320px) and (max-width: 1279px)",
};
export var breakpoints = {
    xxxl: 1680,
    xxl: 1440,
    xl: 1280
};
